import { type AvatarProps } from '@radix-ui/react-avatar';
import { Avatar, AvatarFallback, AvatarImage } from '@shared/ui';
import { Separator } from '@shared/ui';
type UserAvatarProps = {
  user: {
    image: string | null | undefined;
    name: string | null | undefined;
    email?: string | null | undefined;
  };
} & AvatarProps;

export const UserAvatar = ({ user, ...props }: UserAvatarProps) => {
  const initials = user.name?.split(' ').map((name) => name[0]);
  return (
    <Avatar {...props}>
      {user.image ? (
        <AvatarImage alt="Picture" src={user.image} />
      ) : (
        <AvatarFallback>
          <span className="sr-only">{user.name}</span>
          {initials && initials.length >= 2 && (
            <p className="font-medium">{`${initials[0]}${initials[1]}`}</p>
          )}
        </AvatarFallback>
      )}
    </Avatar>
  );
};

const getInitials = (fullName: string) => {
  return fullName.split(' ').map((name) => name[0]);
};

export const UsernameDisplay = ({ user, ...props }: UserAvatarProps) => {
  const initials = getInitials(user.name!);
  return (
    <>
      <div className="hidden items-center gap-2 lg:flex">
        <Separator
          orientation="vertical"
          className="h-8 bg-primary/20 focus:outline-none"
        />
        <p
          className="inset-0 flex items-center justify-evenly rounded-md px-3 py-2 font-sans font-light outline-none ring-0 ring-offset-0 transition-all hover:bg-muted focus:outline-none active:outline-none"
          content={user.email!}
        >
          {user.email}
        </p>
      </div>

      <Avatar {...props} className="lg:hidden">
        <AvatarFallback>
          <span className="sr-only">{user.name}</span>
          {initials && initials.length >= 2 && (
            <p className="font-medium">{`${initials[0]}${initials[1]}`}</p>
          )}
        </AvatarFallback>
      </Avatar>
    </>
  );
};
